import { useLoaderData, useParams } from 'react-router';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams';
import { ContactDetails } from '../../../../../components/ContactDetails/ContactDetails.js';
import type { ContactMasterId } from '../../../../../common/constants/pathInterfaces';
import type { ContactLoaderData } from '../../../../../common/loaders';

export const CompanyInfoContactPath = () => {
  const {
    billingAccounts,
    broadbandSubscriptions,
    contact,
    pendingActionsResponse,
    deviceSubscriptions,
    serviceSubscriptions,
    voiceSubscriptions,
    invitation,
    serviceAgreementsResponse,
  } = useLoaderData() as ContactLoaderData;
  const { contactMasterId } = useParams<ContactMasterId>();
  const { mdmId } = useSearchParams<{ mdmId?: string }>();

  return (
    <ContactDetails
      billingAccounts={billingAccounts!}
      broadbandSubscriptions={broadbandSubscriptions}
      deviceSubscriptions={deviceSubscriptions}
      contact={contact}
      contactMasterId={contactMasterId!}
      mdmId={mdmId!}
      pendingActionsResponse={pendingActionsResponse}
      serviceSubscriptions={serviceSubscriptions}
      voiceSubscriptions={voiceSubscriptions}
      invitation={invitation}
      serviceAgreementsResponse={serviceAgreementsResponse}
    />
  );
};
